import * as React from 'react';
import { Box, Button, IconButton, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import CancelIcon from '@mui/icons-material/Cancel';
import EastRoundedIcon from '@mui/icons-material/EastRounded';

import Modal from '../Modal';

import { TravelPointLabel } from '../../features/Tickets/components/travel-points-switcher/travel-point-label';

export default function ConfirmDestinationModal({
  open,
  handleClose,
  onVerifyDestination,
  selectedOrigin = 'Mexico',
  selectedDestination = 'USA',
}) {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={handleClose}>
      <Paper sx={{ padding: '24px 32px 32px 32px', borderRadius: '8px', maxHeight: '100vh', overflowY: 'auto' }}>
        <Stack justifyContent="space-between" alignItems="flex-end">
          <IconButton onClick={handleClose} sx={{ padding: 0, marginBottom: '8px' }}>
            <CancelIcon fontSize="medium" sx={{ color: '#282032' }} />
          </IconButton>
        </Stack>
        <Stack direction="column" gap="16px">
          <Typography variant="body1" color="primary" fontWeight={700}>
            {t('confirm_destination.title')}
          </Typography>
          <Typography variant="body1" color="secondary.light">
            {t('confirm_destination.check_departure_arrival_to_avoid_travel_issues')}
          </Typography>
          <Stack gap={3} position="relative" direction="row" alignItems="center" justifyContent="center">
            <TravelPointLabel
              py={3}
              px={7}
              label={selectedOrigin}
              isOrigin={true}
              titleVariant="body1"
              subtitleVariant="body2"
            />
            <Box
              sx={{
                width: 40,
                height: 40,
                border: '1px solid rgba(186, 186, 186, 0.30)',
                display: 'flex',
                alignItems: 'center',
                borderRadius: '8px',
                justifyContent: 'center',
                position: 'absolute',
                backgroundColor: '#FEFEFE',
              }}
            >
              <EastRoundedIcon fontSize="medium" sx={{ color: '#EF60A3' }} />
            </Box>
            <TravelPointLabel
              py={3}
              px={7}
              label={selectedDestination}
              isOrigin={false}
              titleVariant="body1"
              subtitleVariant="body2"
            />
          </Stack>
          <Stack gap="32px" marginTop="16px" direction={{ xs: 'column', md: 'row' }}>
            <Button
              sx={{
                color: '#6C6D70 !important',
                height: '44px !important',
                borderColor: '#6C6D70 !important',
              }}
              onClick={handleClose}
              fullWidth
            >
              {t('confirm_destination.edit_selection')}
            </Button>
            <Button size="large" color="primary" variant="contained" onClick={onVerifyDestination} fullWidth>
              {t('continue_register')}
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Modal>
  );
}
